import Vue from "vue";
import VueMarkdown from "vue-markdown";
import VueCarousel from 'vue-carousel';
import VueHeadful from "vue-headful"; 
import VueMasonryCss from "vue-masonry-css";
import VeeValidate from "vee-validate";

// =================================
//	Blocks
// =================================

// Section
import HeaderBlock from "@/components/blocks/header/header.block.vue";
import FooterBlock from "@/components/blocks/footer/footer.block.vue";

// Content Blocks
import LoadingBlock from "@/components/blocks/loading-block/loading.block.vue";
import LoginBlock from "@/components/blocks/login-block/login.block.vue";
import LoadingScreen from "@/components/blocks/loading-screen/loading.screen.vue";
import LogoBlock from "@/components/blocks/logo-block/logo.block.vue";
import VideoBlock from "@/components/blocks/video/video.block.vue";
import ImageBlock from "@/components/blocks/image/image.block.vue";
import FileBlock from "@/components/blocks/file-block/file.block.vue";
import Vector from "@/components/blocks/vector.vue";

// Structure Blocks
import NotificationBlock from "@/components/blocks/notification-block/notification.block.vue";
import InputBlock from "@/components/blocks/input-block/input.block.vue";
import ButtonBlock from "@/components/blocks/button-block/button.block.vue";
import TextBlock from "@/components/blocks/text-block/text.block.vue";
import ListBlock from "@/components/blocks/list-block/list.block.vue";
import LocationBlock from "@/components/blocks/location-block/location.block.vue";
import PaperBlock from "@/components/blocks/paper-block/paper.block.vue";
import CardBlock from "@/components/blocks/card-block/card.block.vue";
import ModalBlock from "@/components/blocks/modal-block/modal.block.vue";

// Graveyard

/**
 * Vue configuration.
*/
Vue.config.productionTip = false;

// Plugins
Vue.component("markdown", VueMarkdown);
Vue.component("vue-headful", VueHeadful);

// Section
Vue.component("header-block", HeaderBlock);
Vue.component("footer-block", FooterBlock);

// Content Blocks
Vue.component("logo-block", LogoBlock);
Vue.component("login-block", LoginBlock);
Vue.component("file-block", FileBlock);
Vue.component("input-block", InputBlock);
Vue.component("loading-block", LoadingBlock);
Vue.component("loading-screen", LoadingScreen);
Vue.component("image-block", ImageBlock);
Vue.component("video-block", VideoBlock);
Vue.component("vector", Vector);

// Structure Blocks
Vue.component("notification-block", NotificationBlock);
Vue.component("button-block", ButtonBlock);
Vue.component("text-block", TextBlock);
Vue.component("list-block", ListBlock);
Vue.component("location-block", LocationBlock);
Vue.component("paper-block", PaperBlock);
Vue.component("card-block", CardBlock);
Vue.component("modal-block", ModalBlock);

// Graveyard

Vue.use(VueMasonryCss);
Vue.use(VeeValidate);
Vue.use(VueCarousel);
// Vue.use(vueScrollto);


// WEBPACK FOOTER //
// ./src/components/blocks/blocks.js